import { render } from "./Matrox.vue?vue&type=template&id=e41feb28"
import script from "./Matrox.vue?vue&type=script&lang=js"
export * from "./Matrox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Vue\\frame2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__